import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PanVerificationPageRoutingModule } from './pan-verification-routing.module';

import { PanVerificationPage } from './pan-verification.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PanVerificationPageRoutingModule
  ],
  declarations: [PanVerificationPage]
})
export class PanVerificationPageModule {}
